export enum AuthFormValue {
  EMAIL = 'email',
  PASSWORD = 'password',
  MARKETING_OPT_IN = 'marketingOptIn'
}

export interface FormValues {
  [AuthFormValue.EMAIL]: string
  [AuthFormValue.PASSWORD]: string
  [AuthFormValue.MARKETING_OPT_IN]: boolean
}

export const INITIAL_FORM_VALUES: FormValues = {
  [AuthFormValue.EMAIL]: '',
  [AuthFormValue.PASSWORD]: '',
  [AuthFormValue.MARKETING_OPT_IN]: false
}
